import { BaseEntity } from '~/app/core/models/base-entity.model';

export class ProfilePassword extends BaseEntity<ProfilePassword> {
  oldpassword?: string;
  newpassword?: string;
  newpasswordconfirm?: string;
}
